// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"b2ac4b6f","453":"7d829d21","648":"53970159"}[chunkId] + ".chunk.js";
};